import { render, staticRenderFns } from "./WriteOffDebtInvoicesPage.vue?vue&type=template&id=31154bbf&scoped=true&"
import script from "./WriteOffDebtInvoicesPage.vue?vue&type=script&lang=ts&"
export * from "./WriteOffDebtInvoicesPage.vue?vue&type=script&lang=ts&"
import style0 from "./WriteOffDebtInvoicesPage.vue?vue&type=style&index=0&id=31154bbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31154bbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VIcon,VTooltip})
